import React, { Component } from "react";
import history from "../login/history";
import PronetTitulo from "./PronetTitulo";
import {mensajeExito} from "../../generico/MensajeSistemaToast";
import PagoServicioService from "../../../services/pagoServicios/pagoServicioService";
import AuthService from "../../../services/login/auth.service";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faArrowLeft, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import CabeceraWizard from "./CabeceraWizard"

export default class PronetPaso4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codigo: props.codigo,
 

    };
  }

  componentDidMount() {

  }
  descargar = async () => {
    await trackPromise(
      PagoServicioService.descagarComprobante("Pagos de Servicios", this.props.nroOperacion, AuthService.getSocio().numeroSocio.trim() +" - "+AuthService.getSocio().nombreCompleto, this.props.cuenta, this.props.paso4)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  };
  volver = (e) => {
   
    //history.push('/PagoServicio');
    history.push(ConfigService.getPathByName("pagoServicio")?.url);
    window.location.reload();
  }

  home = (e) => {
    //history.push('/resumenGeneralSocio');
    history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
    window.location.reload();
  }

  render() {
    if (this.props.currentStep !== 6) { // Prop: The current step
      return null
    }
    if(this.props.currentStep===6){
      mensajeExito("El Pago se Realizó Correctamente")
    } 
    return (
      <div>
        {/******************* CABECERA WIZARD ***********************/}
        <div className="row">
          <CabeceraWizard
            nombre={this.props.nombre}
            tittle1="disabled"
            tittle2="disabled"
            tittle3="disabled"
            tittle4="disabled"
            tittle5="disabled"
            tittle6="current"
          />
          {/* <div class="steps clearfix" style={{marginBottom:5}}>
            <ul role="tablist">
              <li role="tab" class="disabled">
                <span>
                  <div class="title">
                    <span class="title_text">{this.props.nombre}</span>
                  </div>
                </span>
              </li>
              <li role="tab" class="disabled">
                <span>
                  <div class="title">
                    <span class="title_text">Consulta</span>
                  </div>
                </span>
              </li>
              <li role="tab" class="disabled">
                <span>
                  <div class="title">
                    <span class="title_text">Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Código de confirmación</span>
                  </div>
                </span>
              </li>
              <li role="tab" class="disabled">
                <span>
                  <div class="title">
                    <span class="title_text">Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" class="current">
                <span>
                  <div class="title">
                    <span class="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div> */}
        </div>

        <PronetTitulo img={this.props.img} empresa={this.props.empresa} />
        <hr/>

        {/******************* LOGICA PASOS ***********************/}
        <div className="row justify-content-md-center">
          <div className="col-md-10" style={{textAlign: "end"}}>
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}                        
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <h6 style={{ margin: 0 }}>
              Socio: {AuthService.getSocio().numeroSocio.trim()} -{" "}
              {AuthService.getSocio().nombreCompleto}
            </h6>
            <p style={{ marginBottom: 0 }}>
              Cuenta: {this.props.cuenta}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-5 col-md-8">
            <br/>
            <label className="input-label-bold">Comprobante del Pago</label>
            <pre className="pago-servicio-comprobante">
              {this.props.paso4}
            </pre>
          </div>  
        </div>
        <hr />
        <div className="row">
          <div className="col-md-4 btn-consulta">
          <button className="btn btn-cu-secundary"onClick={this.volver}>
          <FontAwesomeIcon icon={faMoneyCheckDollar} />  Pagar Otro Servicio</button>
          </div>
          <div className="col-md-4 btn-consulta"><button className="btn btn-cu-quintary" onClick={this.home}><FontAwesomeIcon icon={faArrowLeft} /> Volver al Inicio</button>
          </div>
          <div className="col-md-4">
          <button className="btn btn-cu-primary" onClick={this.descargar}><FontAwesomeIcon icon={faDownload} /> Descargar Comprobante</button>
          </div>
          
          
          
        </div>
      </div>
    );
  }
}